import React from "react";

interface AscSidebarItemBasicProps {
  id: string;
  children: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

interface AscSidebarItemFunctionProps extends AscSidebarItemBasicProps {
  type: "function";
  path?: undefined;
  parent?: string;
  isParent?: boolean;
  onClick: () => void;
}

interface AscSidebarItemNavigationProps extends AscSidebarItemBasicProps {
  type?: "navigation";
  path: string;
  parent?: string;
  isParent?: boolean;
}

export type AscSidebarItemProps =
  | AscSidebarItemNavigationProps
  | AscSidebarItemFunctionProps;

export default function AscSidebarItem({ children }: AscSidebarItemProps) {
  return <>{children}</>;
}
